import {Injectable} from '@angular/core';
import { LoginService } from '../../services/login.service';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}





@Injectable()
export class MenuItems {
  private elMenu: Menu[] = [];
  private elMenuCliente: Menu[] = [];
  constructor(public loginService: LoginService) {

    const nivel1: MainMenuItems[] = [];
    const nivel1Cliente: MainMenuItems[] = [];
    const nivel2: ChildrenItems[] = [];

    const calendario = { state: 'calendario',
                         name: 'Calendario',
                         type: 'link',
                         icon: 'ti-view-grid'
                       };
    const estudios = { state: 'tiendas',
                         name: 'Tiendas',
                         type: 'link',
                         icon: 'ti-home'
                       };
    const empleados = { state: 'empleados',
                        name: 'Empleados',
                        type: 'link',
                        icon: 'ti-id-badge'
                      };
    const informes = { state: 'informes',
    name: 'Panel de Gestión',
    type: 'link',
    icon: 'ti-archive'
    };
    const listados = { state: 'listados',
    name: 'Informe',
    type: 'link',
    icon: 'ti-archive'
    };
    const turnos = {
      state: 'turnos',
      name: 'Turnos',
    };
    const categorias = {
      state: 'categorias',
      name: 'Categorias'
    };
    const necesidades = {
      state: 'patrones',
      name: 'Patrones'
    };
    const usuarios = {
      state: 'usuarios',
      name: 'Usuarios'
    };
    const tipoEmpleados = {
    state: 'tipo-empleados',
    name: 'Tipos de empleados'
    };
    const ausencias = {
    state: 'ausencias',
    name: 'Ausencias'
    };
    const festivos = {
    state: 'tipo-festivos',
    name: 'Tipo Festivos'
    };
    const addFestivos = {
      state: 'festivos',
      name: 'Festivos'
      };
    const documentacion = {
      state: 'documentacion',
      name: 'Documentación'
    };
    const bolsa = {
      state: 'bolsa-horas',
      name: 'Bolsa de horas'
    };
    if (this.loginService.getRol() === 'ADMINISTRADOR' || this.loginService.getRol() === 'STANDARD') {

      nivel2.push(tipoEmpleados);
      nivel2.push(turnos);
      nivel2.push(necesidades);
      nivel2.push(ausencias);
      nivel2.push(festivos);
      nivel2.push(documentacion);
      nivel2.push(usuarios);
      nivel2.push(bolsa);
      nivel2.push(addFestivos);
    }


    const configuracion = {
                      state: 'maestros',
                      name: 'Configuración',
                      type: 'sub',
                      icon: 'ti-settings',
                      children: nivel2
                    };

//  nivel1.push(calendario);
    nivel1.push(informes);
    nivel1.push(listados);
    nivel1.push(estudios);
    nivel1.push(empleados);
    nivel1.push(configuracion);
    // nivel1.push(trazabilidad);

    nivel1Cliente.push(calendario);
    nivel1Cliente.push(estudios);
    nivel1Cliente.push(empleados);


    this.elMenu = [
      {
      label: 'administración',
      main: nivel1
    }];

    this.elMenuCliente = [
      {
      label: 'administración',
      main: nivel1Cliente
    }];

  }
  getAll(): Menu[] {
    /*
        const numTraza = this.loginService.getNumTrazabilidad();
        if (numTraza > 0) {
          if (this.elMenu[0].main[2].badge[0]) {
            this.elMenu[0].main[2].badge[0].value = numTraza.toString();
          } else {
            this.elMenu[0].main[2].badge = [];
            this.elMenu[0].main[2].badge.push({
                                              type: 'info',
                                              value: numTraza.toString()
                                            });
          }
        } else {
          // elimino el badge si existe
          if (this.elMenu[0].main[2].badge[0]) {
            this.elMenu[0].main[2].badge = [];
          }
        }
    */

   if (this.loginService.getRol() === 'ADMINISTRADOR' || this.loginService.getRol() === 'STANDARD') {
      return this.elMenu;
   } else {
      return this.elMenuCliente;
   }
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/menu-items/menu-items.ts